<div class="overlay" *ngIf="isActive" (click)="overlayClicked()"></div>
<table>
    <thead *ngIf="showHeaders">
        @if(showSelectionBox) {
            <th class="selectbox">
                <input type="checkbox" [checked]="isAllSelected" (click)="selectAll()">
            </th>
        }
        <th *ngFor="let c of data.columns; index as ci" 
        [ngClass]="c.getClass()"
        [class.sortable]="sortable && c.type !== 'actions'"
        [class.uns]="ci !== this.sortColumn"
        [class.asc]="ci == this.sortColumn && this.sortDirection == 'asc'"
        [class.des]="ci == this.sortColumn && this.sortDirection == 'des'"
        (click)="onClick(ci)">{{c.title}}</th>
    </thead>
    <tbody [class.interactive]="interactive">
        <tr *ngFor="let d of displayRows; index as di" [class.activeRow]="di == activeActionRow" (click)="selectRow(di)">
            @if(di !== activeActionRow) {
                @if(showSelectionBox) {
                    <td class="selectbox">
                        @if(d.canSelect) {
                            <input type="checkbox" [checked]="selectedRows.has(di)" (click)="selectIndividualRow($event, di)">
                        } @else {
                            &nbsp;
                        }
                    </td>
                }

                <td *ngFor="let c of d.cols; index as i" 
                    [ngClass]="[data.columns[i].align, data.columns[i].cellClass]">
                    <app-cf-table-cell [columnType]="data.columns[i].type" [column]="c" [options]="data.columns[i].options" [profileSizePx]="profileSizePx" (click)="buttonClicked($event, d.pk)"></app-cf-table-cell>
                </td>
                @if(data.rowActions) {
                    <td class="rowActions cal">
                        <span *ngFor="let a of data.rowActions; index as ri" class="rowActionItem" (click)="rowActionClicked(ri, di, d.pk)">
                            {{a.text}}
                        </span>
                    </td>
                }
            } @else {
                @if(showSelectionBox) {
                    <td class="selectbox">&nbsp;</td>
                }
                @for (c of d.cols; track $index) {
                    @if($index === activeActionStartColumn) {
                        <td colSpan="{{activeActionRowSpan}}" (click)="clearRowAction(di)">
                            @if(activeAction == 0) {
                                <ng-content select="[firstAction]"></ng-content>    
                            }
                            @if(activeAction == 1) {
                                <ng-content select="[secondAction]"></ng-content>    
                            }
                            @if(activeAction == 2) {
                                <ng-content select="[thirdAction]"></ng-content>    
                            }
                        </td>
                    }@else {
                        @if($index < activeActionStartColumn) {
                        <td [ngClass]="[data.columns[$index].align, data.columns[$index].cellClass]">
                            <app-cf-table-cell [columnType]="data.columns[$index].type" [column]="c" [options]="data.columns[$index].options" [profileSizePx]="profileSizePx" (click)="buttonClicked($event, d.pk)"></app-cf-table-cell>
                        </td>
                        }
                    }
                }
                <td class="rowActions" (click)="clearRowAction(di)">
                    @if( activeActionStartColumn === data.columns.length - 1) {
                        @if(activeAction == 0) {
                            <ng-content select="[firstAction]"></ng-content>    
                        }
                        @if(activeAction == 1) {
                            <ng-content select="[secAction]"></ng-content>    
                        }
                        @if(activeAction == 2) {
                            <ng-content select="[thirdAction]"></ng-content>    
                        }
                    }
                </td>
            }

        </tr>
    </tbody>
</table>
@if(displayRows.length !== 0 && data.pages) {
    <!-- IAS - is this a meaningful separate component? -->
    <div class="table-paginate">
        <button type="button" class="uib" [disabled]="df" (click)="setFirstPage()"><i class="fa-solid fa-angles-left" [class.disabled]="df"></i></button>
        <button type="button" class="uib" [disabled]="dp" (click)="previousPage()"><i class="fa-solid fa-angle-left" [class.disabled]="dp" ></i></button>
        <div class="page">{{data.pages.currentPage + 1}}/{{data.pages.pageCount}}</div>
        <button type="button" class="uib" [disabled]="dn" (click)="nextPage()"><i class="fa-solid fa-angle-right" [class.disabled]="dn" ></i></button>
        <button type="button" class="uib" [disabled]="dl" (click)="setLastPage()"><i class="fa-solid fa-angles-right" [class.disabled]="dl" ></i></button>
    </div>
}